import React from 'react';

const CharacterCounter = ({ count, maxLength }) => {
  if (!maxLength) {
    return null;
  }

  return (
    <div 
      style={{ 
        textAlign: 'right', 
        fontSize: '12px', 
        color: count > maxLength ? 'red' : '#888',
        marginTop: '4px'
      }}
    >
      {count}/{maxLength}
    </div>
  );
};

export default CharacterCounter;
